import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  return jsx("div", {
    sel: '.mp-radio-button-wrapper',
    class: {
      'mp-radio-button-selected': this.attr("selected"),
      'mp-radio-button-disabled': this.attr("disabled"),
      'mp-radio-button-focused': this.attr("focused"),
      'mp-radio-button-lite': this.attr("theme") === "lite",
      'mp-radio-button-primary': this.attr("theme") === "primary"
    }
  }, jsx("div", {
    sel: '.mp-radio-button-button'
  }, jsx("div", {
    sel: '.mp-radio-button-animation-layer'
  }), jsx("div", {
    sel: '.mp-radio-button-dot'
  })), this.attr("icon") ? jsx("div", {
    sel: '.mp-radio-button-content'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: this.attr("icon")
    }
  })) : null, jsx("slot", null));
}